import { render, staticRenderFns } from "./penaltyList.vue?vue&type=template&id=040ead3a&scoped=true"
import script from "./penaltyList.vue?vue&type=script&lang=js"
export * from "./penaltyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ead3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('040ead3a')) {
      api.createRecord('040ead3a', component.options)
    } else {
      api.reload('040ead3a', component.options)
    }
    module.hot.accept("./penaltyList.vue?vue&type=template&id=040ead3a&scoped=true", function () {
      api.rerender('040ead3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/report/pdfDataInfo/mainRewardInfo/penaltyList.vue"
export default component.exports